import {call, put, takeEvery} from "redux-saga/effects";
import {
    GET_SUBSCRIPTIONS,
    GET_TOPUP_PLANS,
    GET_USERS_TOKENS_UTILIZATION,
    setUsersTokensUtilization,
    setUsersBalanceLoading,
    setUsersBalanceError,
    setSubscriptions,
    setSubscriptionsLoading,
    setSubscriptionsError,
    setTopupPlans,
    setTopupPlansLoading,
    setTopupPlansError
} from "../actions/meta.action";
import commonService from "../../services/common.service";



const getSubscriptionPlansList = () =>{
    return commonService._payments_Service.getSubscriptionPlans({})
}

const getTopupPlansList = () =>{
    return commonService._payments_Service.getTopupPlans({})
}

const getUserTokensUsagePercentage = () =>{
    return commonService._account.get_token_utilization({})
}


function* loadSubscriptions() {
    try {
        // Set loading state to true
        yield put(setSubscriptionsLoading(true));
        yield put(setSubscriptionsError(null));
        
        // @ts-expect-error disabled
        const subscriptions: any = yield call(getSubscriptionPlansList);
        
        // Set loading state to false and update subscriptions
        yield put(setSubscriptionsLoading(false));
        yield put(setSubscriptions(subscriptions?.data || []));
    } catch (error) {
        console.error('Error loading subscriptions:', error);
        
        // Set loading state to false and set error
        yield put(setSubscriptionsLoading(false));
        yield put(setSubscriptionsError(error instanceof Error ? error.message : 'Failed to load subscription plans'));
        yield put(setSubscriptions([]));
    }
}

function* loadUserTokensUsagePercentage() {
    try {
        // Set loading state to true
        yield put(setUsersBalanceLoading(true));
        yield put(setUsersBalanceError(null));
        
        // @ts-expect-error disabled
        const usagePercentage: any = yield call(getUserTokensUsagePercentage);

        // Set loading state to false and update users balance
        yield put(setUsersBalanceLoading(false));
        yield put(setUsersTokensUtilization(usagePercentage?.data || {}));
    } catch (error) {
        console.error('Error loading user tokens utilization:', error);
        
        // Set loading state to false and set error
        yield put(setUsersBalanceLoading(false));
        yield put(setUsersBalanceError(error instanceof Error ? error.message : 'Failed to load user balance'));
        yield put(setUsersTokensUtilization({
            total_budget: 0,
            user_used_budget: 0,
            user_remaining_budget: 0,
            gift_credits: 0,
            subscription_credits: 0,
            topup_credits: 0,
        }));
    }
}

function* loadTopupPlans() {
    try {
        // Set loading state to true
        yield put(setTopupPlansLoading(true));
        yield put(setTopupPlansError(null));
        
        // @ts-expect-error disabled
        const topupPlans: any = yield call(getTopupPlansList);
        
        // Set loading state to false and update topup plans
        yield put(setTopupPlansLoading(false));
        yield put(setTopupPlans(topupPlans?.data || []));
    } catch (error) {
        console.error('Error loading top-up plans:', error);
        
        // Set loading state to false and set error
        yield put(setTopupPlansLoading(false));
        yield put(setTopupPlansError(error instanceof Error ? error.message : 'Failed to load top-up plans'));
        yield put(setTopupPlans([]));
    }
}

export default function* metaSaga() {
    yield takeEvery(GET_SUBSCRIPTIONS, loadSubscriptions);
    yield takeEvery(GET_TOPUP_PLANS, loadTopupPlans);
    yield takeEvery(GET_USERS_TOKENS_UTILIZATION, loadUserTokensUsagePercentage);
}


